<script setup lang="ts">
import SkeletonLoader from '@/components/base/skeleton/SkeletonLoader.vue'
</script>
<template>
  <div w-full flex="~ col">
    <SkeletonLoader mx-4 mb-14 mt-14 mb-6 class="w-90 h-12" />
    <p mb-6 rounded-2 py-4 mx-2 px-4 md:mx-4 md:px-6 md:py-4 bg-code>
      <SkeletonLoader my-2 class="w-6/12 h-6" />
      <SkeletonLoader my-2 class="w-3/12 h-6" />
      <SkeletonLoader my-2 class="w-4/12 h-6" />
      <SkeletonLoader my-2 class="w-8/12 h-6" />
    </p>
    <div px-4>
      <SkeletonLoader my-8 class="w-50 h-10" />
      <SkeletonLoader my-2 class="w-full h-6" />
      <SkeletonLoader my-2 class="w-full h-6" />
      <SkeletonLoader my-2 class="w-full h-6" />
      <SkeletonLoader my-2 class="w-full h-6" />
      <SkeletonLoader my-2 class="w-8/12 h-6" />

      <SkeletonLoader mb-2 mt-4 class="w-full h-6" />
      <SkeletonLoader my-2 class="w-6/12 h-6" />

      <SkeletonLoader my-8 class="w-42 h-8" />
      <SkeletonLoader my-2 class="w-full h-6" />
      <SkeletonLoader my-2 class="w-6/12 h-6" />
    </div>
    <div flex="~ row" relative mb-2 mt-14 h-12 w-full items-center justify-end text-sm>
      <div flex="~ row" mr-3 mt-0.5 items-center>
        <SkeletonLoader my-2 mr-4 class="w-40 h-6" />
        <SkeletonLoader my-2 mr-4 class="w-25 h-4" />
        <SkeletonLoader my-2 class="w-8 h-8" />
      </div>
    </div>
    <SkeletonLoader mx-4 mt-16 class="w-30 h-10" />
    <div grid grid-cols-2 grid-flow-col gap-4 px-4 mt-10>
      <SkeletonLoader class="w-full h-40" />
      <SkeletonLoader class="w-full h-60" />
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
